import React, { Fragment, useEffect, useState } from "react";
import { RestHelper } from "../../helper/restHelper";
import RonBadge, { isRon } from "../ron-badge";

const AdminPickNewNotary = (data) => {
    const [errorMessage, setErrorMessage] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [notaryState, setNotaryState] = useState('10 miles')
    const [zipCode, setZipCode] = useState('')
    const [apiRes, setApiRes] = useState([])
    const [showResults, setShowResults] = useState(false)
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [newNotary, setNewNotary] = useState('')
    const [newNotaryEmail, setNewNotaryEmail] = useState('')
    const [notaryMessage, setNotaryMessage] = useState('')
    const [notarySelected, setNotarySelected] = useState(false)
    const [selectedValue, setSelectedValue] = useState('')
    const [showResponse, setShowResponse] = useState(false)
    const [updateResponse, setUpdateResponse] = useState([])
    const api = RestHelper()

    useEffect(() => {
        getNotaryList()
    }, [])

    const setResponse = (res) => {
        setApiRes(res)
    }

    function handleSelect(evt, email) {
        setSelectedValue(evt)
        setNewNotary(evt.notary_first_name + ' ' + evt.notary_last_name)
        setNewNotaryEmail(email)
        setNotarySelected(true)
    }

    function updateNotary() {
        assignNewNotary()
    }

    const onChangeEvent = (e) => {
        setNotaryMessage(e.target.value)
    }

    const getNotaryList = () => {
        const options = {}
        const params = { 'request_id': data.requestId, 'action': 'getNotaryBidList' }
        api
            .postCreate('/manage-appts-admin', options, params)
            .then(res => setResponse(res))
            .catch(err => console.log(err))
        setShowResults(true)
        setShowResponse(true)
    }

    const assignNewNotary = () => {
        const options = {}
        const params = { 'request_id': data.requestId, 'action': 'updateNotary', 'newNotary': newNotaryEmail, 'notaryNotes': notaryMessage }
        api
            .postCreate('/manage-appts-admin', options, params)
            .then(res => setUpdateResponse(res))
            .catch(err => console.log(err))
    }

    function clearErrorMessage() {
        setErrorMessage(false)
    }

    return (
        <Fragment>
            {errorMessage && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 mb-4 overflow-hidden">
                    <div className="px-4 py-3 border-b border-neutral-200 flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-neutral-800">Appointment Status</h2>
                        <button
                            className="text-neutral-400 hover:text-neutral-600 p-1"
                            onClick={() => clearErrorMessage()}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="p-4 sm:p-6">
                        <p className="text-neutral-700 mb-2">{apiMessage}</p>
                        <p className="font-medium text-neutral-800">{apiDetails}</p>
                    </div>
                </div>
            )}

            {showForm && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 mb-4 overflow-hidden">
                    <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                        <h2 className="text-lg font-semibold text-neutral-800">Update Signing Agent Assignment</h2>
                        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                    </div>
                    <div className="p-4 sm:p-6">
                        {data.notary.map((items, index) => (
                            <div key={index}>
                                <div className="mb-4">
                                    <label htmlFor="notaryNotes" className="block text-sm font-medium text-neutral-700 mb-2">
                                        Notes for displaced signing agent (optional):
                                    </label>
                                    <input
                                        className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        id="notaryNotes"
                                        onChange={(e) => onChangeEvent(e)}
                                        type="text"
                                        value={notaryMessage}
                                    />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div className="bg-neutral-50 p-4 rounded-lg border border-neutral-200">
                                        <span className="text-sm text-neutral-500">Currently Assigned:</span>
                                        <p className="font-medium text-neutral-800">{items.assigned_notary || 'None'}</p>
                                    </div>
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                        <span className="text-sm text-blue-600">New Signing Agent:</span>
                                        <p className="font-medium text-blue-800">{newNotary || 'Select from list below'}</p>
                                    </div>
                                </div>
                                {data.apptRon && notarySelected && !isRon(selectedValue.ronCertified) && (
                                    <div className="bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded-lg mb-4 text-sm">
                                        This is a RON order and the selected agent is not RON certified.
                                    </div>
                                )}
                                {notarySelected && (
                                    <button
                                        type="button"
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                                        onClick={() => updateNotary()}
                                    >
                                        Update Notary
                                    </button>
                                )}
                            </div>
                        ))}

                        {showResponse && updateResponse.length > 0 && (
                            <div className="mt-4 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
                                {updateResponse.map((items, index) => (
                                    <div key={index}>{items.message}</div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showResults && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                    <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                        <h2 className="text-lg font-semibold text-neutral-800">Available Signing Agents</h2>
                        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                    </div>
                    <div className="overflow-x-auto max-h-52">
                        <table className="w-full text-sm">
                            <thead className="bg-neutral-50 border-b border-neutral-200 sticky top-0">
                                <tr>
                                    <th className="px-4 py-3 text-left font-semibold text-neutral-700">Signing Agent Name</th>
                                    <th className="px-4 py-3 text-left font-semibold text-neutral-700">Phone</th>
                                    <th className="px-4 py-3 text-left font-semibold text-neutral-700">Email</th>
                                    <th className="px-4 py-3 text-left font-semibold text-neutral-700">Bid</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-neutral-100">
                                {apiRes.map((items, index) => (
                                    <tr
                                        key={index}
                                        className={`cursor-pointer transition-colors ${selectedValue === items ? 'bg-blue-100' : 'hover:bg-neutral-50'}`}
                                        onClick={() => handleSelect(items, items.notary_email)}
                                    >
                                        <td className="px-4 py-3 text-neutral-800">{items.notary_first_name} {items.notary_last_name}{isRon(items.ronCertified) && <RonBadge className="ml-2" />}</td>
                                        <td className="px-4 py-3 text-neutral-600">{items.notary_phone}</td>
                                        <td className="px-4 py-3 text-neutral-600">{items.notary_email}</td>
                                        <td className="px-4 py-3 text-blue-600 font-semibold">${items.notary_bid}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {apiRes.length === 0 && (
                            <p className="text-neutral-500 text-center py-4">No agents available</p>
                        )}
                    </div>
                </div>
            )}
        </Fragment>
    )
};

export default AdminPickNewNotary;
